import { render, staticRenderFns } from "./WorkspaceUsersListItem.vue?vue&type=template&id=7c5422f2&scoped=true&"
import script from "./WorkspaceUsersListItem.vue?vue&type=script&lang=js&"
export * from "./WorkspaceUsersListItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceUsersListItem.vue?vue&type=style&index=0&id=7c5422f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5422f2",
  null
  
)

export default component.exports